/**
 * Отказ загрузки чанка у webpack (используется некоторыми зависимостями
 * и старыми сборками) называется так по имени класса ошибки.
 */
const CHUNK_LOAD_ERROR_NAMES = new Set(["ChunkLoadError"]);

/**
 * Единого имени ошибки динамического import() у браузеров нет, поэтому
 * распознаём по тексту: Chrome/Edge, Firefox и Safari формулируют отказ
 * загрузки модуля по-разному. Vite при неудачном preload (см.
 * app/preloadError.ts) в итоге тоже приводит к одной из этих ошибок,
 * когда перезагрузка уже не положена (лимит исчерпан).
 */
const CHUNK_LOAD_MESSAGE_PATTERNS = [
  /Failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /Importing a module script failed/i,
];

function errorShape(error: unknown): { name?: string; message?: string } {
  if (error instanceof Error) {
    return { name: error.name, message: error.message };
  }
  if (typeof error === "object" && error !== null) {
    const { name, message } = error as { name?: unknown; message?: unknown };
    return {
      name: typeof name === "string" ? name : undefined,
      message: typeof message === "string" ? message : undefined,
    };
  }
  return {};
}

/**
 * true только для отказа загрузки чанка динамического import() (не
 * загрузился файл), false для любой другой ошибки, включая настоящий баг
 * в коде редактора: смешивать их в одном тексте «не удалось загрузить,
 * проверьте соединение» значило бы прятать реальные баги под сетевым
 * симптомом и никогда не отправлять их в мониторинг (см.
 * AutomationEditorErrorBoundary, которая по этому предикату решает,
 * репортить ли ошибку и какой текст показать).
 */
export function isChunkLoadError(error: unknown): boolean {
  const { name, message } = errorShape(error);
  if (name && CHUNK_LOAD_ERROR_NAMES.has(name)) return true;
  if (!message) return false;
  return CHUNK_LOAD_MESSAGE_PATTERNS.some((pattern) => pattern.test(message));
}
